import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addProductMediaRequest = {};
var _addProductMediaResponse = {};
var _addProductMediaToChoicesRequest = {};
var _addProductMediaToChoicesResponse = {};
var _addProductsToCollectionRequest = {};
var _addProductsToCollectionResponse = {};
var _adjustValue = {
    price: '_propertyAdjustmentData',
    cost: '_propertyAdjustmentData',
    weight: '_propertyAdjustmentData',
};
var _aggregateProductsRequest = {};
var _aggregateProductsResponse = {};
var _bulkAdjustProductPropertiesByFilterSyncRequest = {
    adjust: '_adjustValue',
};
var _bulkAdjustProductPropertiesByFilterSyncResponse = {};
var _bulkAdjustProductPropertiesRequest = { adjust: '_adjustValue' };
var _bulkAdjustProductPropertiesResponse = {};
var _bulkDeleteProductsRequest = {};
var _bulkDeleteProductsResponse = {};
var _bulkRemoveCustomFieldsRequest = {};
var _bulkRemoveCustomFieldsResponse = {};
var _bulkSetCustomFieldsRequest = {};
var _bulkSetCustomFieldsResponse = {};
var _bulkUpdateProductsByFilterSyncRequest = { set: '_setValue' };
var _bulkUpdateProductsByFilterSyncResponse = {};
var _bulkUpdateProductsRequest = { set: '_setValue' };
var _bulkUpdateProductsResponse = {};
var _collection = { lastUpdated: 'google.protobuf.Timestamp' };
var _costAndProfitData = {
    itemCost: 'google.protobuf.DoubleValue',
    profit: 'DOUBLE',
    profitMargin: 'DOUBLE',
};
var _createCollectionRequest = { collection: '_collection' };
var _createCollectionResponse = { collection: '_collection' };
var _createDigitalProductRequest = { product: '_product' };
var _createDigitalProductResponse = { product: '_product' };
var _createProductPlatformizedRequest = { product: '_product' };
var _createProductPlatformizedResponse = { product: '_product' };
var _createProductRequest = { product: '_product' };
var _createProductResponse = { product: '_product' };
var _deleteCollectionRequest = {};
var _deleteCollectionResponse = {};
var _deleteProductOptionsRequest = {};
var _deleteProductOptionsResponse = {};
var _deleteProductPlatformizedRequest = {};
var _deleteProductPlatformizedResponse = {};
var _deleteProductRequest = {};
var _deleteProductResponse = {};
var _discount = { value: 'DOUBLE' };
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _getCollectionBySlugRequest = {};
var _getCollectionBySlugResponse = { collection: '_collection' };
var _getCollectionRequest = {};
var _getCollectionResponse = { collection: '_collection' };
var _getProductPlatformizedRequest = {};
var _getProductPlatformizedResponse = { product: '_product' };
var _getProductRequest = {};
var _getProductResponse = { product: '_product' };
var _getStoreVariantRequest = {};
var _getStoreVariantResponse = { variant: '_storeVariant' };
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _numericPropertyRange = { minValue: 'DOUBLE', maxValue: 'DOUBLE' };
var _platformMedia = { image: '_image', video: '_videoV2' };
var _priceData = {
    price: 'google.protobuf.DoubleValue',
    discountedPrice: 'DOUBLE',
    pricePerUnit: 'google.protobuf.DoubleValue',
};
var _pricePerUnitData = { totalQuantity: 'DOUBLE', baseQuantity: 'DOUBLE' };
var _product = {
    weight: 'google.protobuf.DoubleValue',
    lastUpdated: 'google.protobuf.Timestamp',
    createdDate: 'google.protobuf.Timestamp',
    weightRange: '_numericPropertyRange',
    price: '_priceData',
    priceData: '_priceData',
    convertedPriceData: '_priceData',
    priceRange: '_numericPropertyRange',
    costAndProfitData: '_costAndProfitData',
    costRange: '_numericPropertyRange',
    pricePerUnitData: '_pricePerUnitData',
    discount: '_discount',
    variants: '_variant',
};
var _productOptionsAvailabilityRequest = {};
var _productOptionsAvailabilityResponse = { selectedVariant: '_variantData' };
var _propertyAdjustmentData = { amount: 'DOUBLE' };
var _queryCollectionsRequest = {};
var _queryCollectionsResponse = { collections: '_collection' };
var _queryProductsPlatformizedRequest = {};
var _queryProductsPlatformizedResponse = { products: '_product' };
var _queryProductsRequest = {};
var _queryProductsResponse = { products: '_product' };
var _queryProductsWithBigPageLimitRequest = {};
var _queryProductVariantsRequest = {};
var _queryProductVariantsResponse = { variants: '_variant' };
var _queryStoreVariantsRequest = {};
var _queryStoreVariantsResponse = { variants: '_storeVariant' };
var _queryStoreVariantsWithBigLimitRequest = {};
var _reCloneStoreRequest = {};
var _reCloneStoreResponse = {};
var _removeCustomFieldsRequest = {};
var _removeCustomFieldsResponse = {};
var _removeProductBrandRequest = {};
var _removeProductBrandResponse = {};
var _removeProductMediaFromChoicesRequest = {};
var _removeProductMediaFromChoicesResponse = {};
var _removeProductMediaRequest = {};
var _removeProductMediaResponse = {};
var _removeProductRibbonRequest = {};
var _removeProductRibbonResponse = {};
var _removeProductsFromCollectionRequest = {};
var _removeProductsFromCollectionResponse = {};
var _resetAllVariantDataRequest = {};
var _resetAllVariantDataResponse = {};
var _setCustomFieldsRequest = {};
var _setCustomFieldsResponse = {};
var _setValue = { price: 'DOUBLE', cost: 'DOUBLE', weight: 'DOUBLE' };
var _storeVariant = { media: '_platformMedia' };
var _updateCollectionRequest = { collection: '_collection' };
var _updateCollectionResponse = { collection: '_collection' };
var _updateProductPlatformizedRequest = { product: '_product' };
var _updateProductPlatformizedResponse = { product: '_product' };
var _updateProductRequest = { product: '_product' };
var _updateProductResponse = { product: '_product' };
var _updateVariantsRequest = { variants: '_variantOverride' };
var _updateVariantsResponse = { variants: '_variant' };
var _v1CreateProductPlatformizedRequest = { product: '_product' };
var _v1CreateProductPlatformizedResponse = { product: '_product' };
var _v1DeleteProductPlatformizedRequest = {};
var _v1DeleteProductPlatformizedResponse = {};
var _v1UpdateProductPlatformizedRequest = { product: '_product' };
var _v1UpdateProductPlatformizedResponse = { product: '_product' };
var _variant = { variant: '_variantDataWithNoStock' };
var _variantData = {
    weight: 'google.protobuf.DoubleValue',
    price: '_priceData',
    convertedPriceData: '_priceData',
};
var _variantDataWithNoStock = {
    weight: 'DOUBLE',
    priceData: '_priceData',
    convertedPriceData: '_priceData',
    costAndProfitData: '_costAndProfitData',
};
var _variantOverride = {
    price: 'google.protobuf.DoubleValue',
    cost: 'google.protobuf.DoubleValue',
    weight: 'google.protobuf.DoubleValue',
};
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
function resolveWixCatalogApiV1CatalogWriteApiUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/catalog-server',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/catalog-server',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/stores/v1/collections',
                destPath: '/v1/collections',
            },
            {
                srcPath: '/stores/v1/products',
                destPath: '/v1/products',
            },
            {
                srcPath: '/stores/v1/variants',
                destPath: '/v1/variants',
            },
            {
                srcPath: '/stores/v1/bulk/products',
                destPath: '/v1/bulk/products',
            },
            {
                srcPath: '/stores/v1/products-digital',
                destPath: '/v1/products-digital',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/catalog-server',
                destPath: '',
            },
            {
                srcPath: '/catalog-write-api-proxy',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/catalog-write-api-proxy',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/catalog-write-api-proxy',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/catalog-write-api-proxy',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/catalog-write-api-proxy',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/catalog-write-api-proxy',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixCatalogApiV1CatalogReadApiUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/catalog-reader-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/catalog-reader-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/catalog-reader-server',
                destPath: '',
            },
            {
                srcPath: '/catalog-read-proxy',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/catalog-reader-server',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/stores-reader/v1/products',
                destPath: '/v1/products',
            },
            {
                srcPath: '/stores-reader/v1/variants',
                destPath: '/v1/variants',
            },
            {
                srcPath: '/stores-reader/api/v1/products',
                destPath: '/api/v1/products',
            },
            {
                srcPath: '/stores-reader/v1/collections',
                destPath: '/v1/collections',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/catalog-read-proxy',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/catalog-read-proxy',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/catalog-read-proxy',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/catalog-read-proxy',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixCatalogWriteProxyV1CatalogWriteProxyUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new product. */
export function writeProxyCreateProductPlatformized(payload) {
    var _a = serializer(_v1CreateProductPlatformizedRequest, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1CreateProductPlatformizedResponse, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }).fromJSON;
    function __writeProxyCreateProductPlatformized(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.write.proxy.v1.CatalogWriteProxy.CreateProductPlatformized',
            url: resolveWixCatalogWriteProxyV1CatalogWriteProxyUrl({
                protoPath: '/v2/products-platformized',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __writeProxyCreateProductPlatformized.fromReq = fromReq;
    __writeProxyCreateProductPlatformized.__isAmbassador = true;
    return __writeProxyCreateProductPlatformized;
}
/** Updates specified fields in a product. */
export function writeProxyUpdateProductPlatformized(payload) {
    var _a = serializer(_v1UpdateProductPlatformizedRequest, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1UpdateProductPlatformizedResponse, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }).fromJSON;
    function __writeProxyUpdateProductPlatformized(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'PATCH',
            methodFqn: 'wix.catalog.write.proxy.v1.CatalogWriteProxy.UpdateProductPlatformized',
            url: resolveWixCatalogWriteProxyV1CatalogWriteProxyUrl({
                protoPath: '/v2/products-platformized/{product.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __writeProxyUpdateProductPlatformized.fromReq = fromReq;
    __writeProxyUpdateProductPlatformized.__isAmbassador = true;
    return __writeProxyUpdateProductPlatformized;
}
/** Deletes a product. */
export function writeProxyDeleteProductPlatformized(payload) {
    var _a = serializer(_v1DeleteProductPlatformizedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v1DeleteProductPlatformizedResponse, {}).fromJSON;
    function __writeProxyDeleteProductPlatformized(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'DELETE',
            methodFqn: 'wix.catalog.write.proxy.v1.CatalogWriteProxy.DeleteProductPlatformized',
            url: resolveWixCatalogWriteProxyV1CatalogWriteProxyUrl({
                protoPath: '/v2/products-platformized/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __writeProxyDeleteProductPlatformized.fromReq = fromReq;
    __writeProxyDeleteProductPlatformized.__isAmbassador = true;
    return __writeProxyDeleteProductPlatformized;
}
/**
 * Returns a list of up to 100 products, given the provided paging, sorting and filtering.
 * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
 */
export function queryProducts(payload) {
    var _a = serializer(_queryProductsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryProductsResponse, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }).fromJSON;
    function __queryProducts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogReadApi.QueryProducts',
            url: resolveWixCatalogApiV1CatalogReadApiUrl({
                protoPath: '/v1/products/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryProducts.fromReq = fromReq;
    __queryProducts.__isAmbassador = true;
    return __queryProducts;
}
/** Returns a list of up to 100 products, given the provided paging, sorting and filtering. */
export function queryProductsPlatformized(payload) {
    var _a = serializer(_queryProductsPlatformizedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryProductsPlatformizedResponse, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }).fromJSON;
    function __queryProductsPlatformized(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'GET',
            methodFqn: 'wix.catalog.api.v1.CatalogReadApi.QueryProductsPlatformized',
            url: resolveWixCatalogApiV1CatalogReadApiUrl({
                protoPath: '/v1/products/query-platformized',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixCatalogApiV1CatalogReadApiUrl({
                        protoPath: '/v1/products/query-platformized',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __queryProductsPlatformized.fromReq = fromReq;
    __queryProductsPlatformized.__isAmbassador = true;
    return __queryProductsPlatformized;
}
/**
 * Returns a list of up to 600 products, given the provided paging, sorting and filtering.
 * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
 */
export function queryProductsWithBigPageLimit(payload) {
    var _a = serializer(_queryProductsWithBigPageLimitRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryProductsResponse, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }).fromJSON;
    function __queryProductsWithBigPageLimit(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogReadApi.QueryProductsWithBigPageLimit',
            url: resolveWixCatalogApiV1CatalogReadApiUrl({
                protoPath: '/v1/products/query-with-big-page-limit',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryProductsWithBigPageLimit.fromReq = fromReq;
    __queryProductsWithBigPageLimit.__isAmbassador = true;
    return __queryProductsWithBigPageLimit;
}
/** Retrieves a product with the provided ID. */
export function getProduct(payload) {
    var _a = serializer(_getProductRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getProductResponse, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }).fromJSON;
    function __getProduct(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'GET',
            methodFqn: 'wix.catalog.api.v1.CatalogReadApi.GetProduct',
            url: resolveWixCatalogApiV1CatalogReadApiUrl({
                protoPath: '/v1/products/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixCatalogApiV1CatalogReadApiUrl({
                        protoPath: '/v1/products/{id}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getProduct.fromReq = fromReq;
    __getProduct.__isAmbassador = true;
    return __getProduct;
}
/** Retrieves a product with the provided ID. */
export function getProductPlatformized(payload) {
    var _a = serializer(_getProductPlatformizedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getProductPlatformizedResponse, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }).fromJSON;
    function __getProductPlatformized(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'GET',
            methodFqn: 'wix.catalog.api.v1.CatalogReadApi.GetProductPlatformized',
            url: resolveWixCatalogApiV1CatalogReadApiUrl({
                protoPath: '/v1/products-platformized/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getProductPlatformized.fromReq = fromReq;
    __getProductPlatformized.__isAmbassador = true;
    return __getProductPlatformized;
}
/**
 * Retrieves a list of up to 100 collections, given the provided paging, sorting and filtering.
 * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
 */
export function queryCollections(payload) {
    var _a = serializer(_queryCollectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCollectionsResponse, {
        _collection: _collection,
    }).fromJSON;
    function __queryCollections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogReadApi.QueryCollections',
            url: resolveWixCatalogApiV1CatalogReadApiUrl({
                protoPath: '/v1/collections/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCollections.fromReq = fromReq;
    __queryCollections.__isAmbassador = true;
    return __queryCollections;
}
/** Retrieves a collection with the provided ID. */
export function getCollection(payload) {
    var _a = serializer(_getCollectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCollectionResponse, {
        _collection: _collection,
    }).fromJSON;
    function __getCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'GET',
            methodFqn: 'wix.catalog.api.v1.CatalogReadApi.GetCollection',
            url: resolveWixCatalogApiV1CatalogReadApiUrl({
                protoPath: '/v1/collections/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixCatalogApiV1CatalogReadApiUrl({
                        protoPath: '/v1/collections/{id}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getCollection.fromReq = fromReq;
    __getCollection.__isAmbassador = true;
    return __getCollection;
}
/** Retrieves a collection with the provided slug. */
export function getCollectionBySlug(payload) {
    var _a = serializer(_getCollectionBySlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCollectionBySlugResponse, {
        _collection: _collection,
    }).fromJSON;
    function __getCollectionBySlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'GET',
            methodFqn: 'wix.catalog.api.v1.CatalogReadApi.GetCollectionBySlug',
            url: resolveWixCatalogApiV1CatalogReadApiUrl({
                protoPath: '/v1/collections/slug/{slug}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCollectionBySlug.fromReq = fromReq;
    __getCollectionBySlug.__isAmbassador = true;
    return __getCollectionBySlug;
}
/** Gets the availability of relevant product variants based on the product ID and selections provided. See [Use Cases](https://dev.wix.com/api/rest/wix-stores/catalog/use-cases) for an example. */
export function productOptionsAvailability(payload) {
    var _a = serializer(_productOptionsAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_productOptionsAvailabilityResponse, { _priceData: _priceData, _variantData: _variantData }).fromJSON;
    function __productOptionsAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogReadApi.ProductOptionsAvailability',
            url: resolveWixCatalogApiV1CatalogReadApiUrl({
                protoPath: '/v1/products/{id}/productOptionsAvailability',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __productOptionsAvailability.fromReq = fromReq;
    __productOptionsAvailability.__isAmbassador = true;
    return __productOptionsAvailability;
}
/**
 * Retrieves product variants, based on either choices (option-choice key-value pairs) or variant IDs.
 * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
 */
export function queryProductVariants(payload) {
    var _a = serializer(_queryProductVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryProductVariantsResponse, {
        _costAndProfitData: _costAndProfitData,
        _priceData: _priceData,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }).fromJSON;
    function __queryProductVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogReadApi.QueryProductVariants',
            url: resolveWixCatalogApiV1CatalogReadApiUrl({
                protoPath: '/v1/products/{id}/variants/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryProductVariants.fromReq = fromReq;
    __queryProductVariants.__isAmbassador = true;
    return __queryProductVariants;
}
/** Retrieves up to 100 store variants, given the provided paging, filtering, and sorting. */
export function queryStoreVariants(payload) {
    var _a = serializer(_queryStoreVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryStoreVariantsResponse, {
        _focalPoint: _focalPoint,
        _image: _image,
        _platformMedia: _platformMedia,
        _storeVariant: _storeVariant,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __queryStoreVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogReadApi.QueryStoreVariants',
            url: resolveWixCatalogApiV1CatalogReadApiUrl({
                protoPath: '/v1/variants/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryStoreVariants.fromReq = fromReq;
    __queryStoreVariants.__isAmbassador = true;
    return __queryStoreVariants;
}
/** Retrieves up to 1000 store variants, given the provided paging, filtering, and sorting. */
export function queryStoreVariantsWithBigLimit(payload) {
    var _a = serializer(_queryStoreVariantsWithBigLimitRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryStoreVariantsResponse, {
        _focalPoint: _focalPoint,
        _image: _image,
        _platformMedia: _platformMedia,
        _storeVariant: _storeVariant,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __queryStoreVariantsWithBigLimit(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogReadApi.QueryStoreVariantsWithBigLimit',
            url: resolveWixCatalogApiV1CatalogReadApiUrl({
                protoPath: '/v1/variants/query-with-big-limit',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryStoreVariantsWithBigLimit.fromReq = fromReq;
    __queryStoreVariantsWithBigLimit.__isAmbassador = true;
    return __queryStoreVariantsWithBigLimit;
}
/** Retrieves a store variant with the provided ID. */
export function getStoreVariant(payload) {
    var _a = serializer(_getStoreVariantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStoreVariantResponse, {
        _focalPoint: _focalPoint,
        _image: _image,
        _platformMedia: _platformMedia,
        _storeVariant: _storeVariant,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getStoreVariant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'GET',
            methodFqn: 'wix.catalog.api.v1.CatalogReadApi.GetStoreVariant',
            url: resolveWixCatalogApiV1CatalogReadApiUrl({
                protoPath: '/v1/variants/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStoreVariant.fromReq = fromReq;
    __getStoreVariant.__isAmbassador = true;
    return __getStoreVariant;
}
/**
 * Before open to users we should support group by field which will impact all aggregations
 * Group by field is optional, in case you want to count all, max on all etc
 * Issue: for count we allow 2-dimensional aggregation which will not be supported when group by single field
 * To support group by we need to add support of it in object-search library
 * This is exposed only to internal since it has limitations and there isn't an aggregate spec yet
 */
export function aggregateProducts(payload) {
    var _a = serializer(_aggregateProductsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_aggregateProductsResponse, {}).fromJSON;
    function __aggregateProducts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogReadApi.AggregateProducts',
            url: resolveWixCatalogApiV1CatalogReadApiUrl({
                protoPath: '/v1/products/aggregate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __aggregateProducts.fromReq = fromReq;
    __aggregateProducts.__isAmbassador = true;
    return __aggregateProducts;
}
/** Creates a new product. */
export function createProduct(payload) {
    var _a = serializer(_createProductRequest, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createProductResponse, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }).fromJSON;
    function __createProduct(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.CreateProduct',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createProduct.fromReq = fromReq;
    __createProduct.__isAmbassador = true;
    return __createProduct;
}
/** Creates a new product. */
export function createProductPlatformized(payload) {
    var _a = serializer(_createProductPlatformizedRequest, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createProductPlatformizedResponse, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }).fromJSON;
    function __createProductPlatformized(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.CreateProductPlatformized',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products-platformized',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createProductPlatformized.fromReq = fromReq;
    __createProductPlatformized.__isAmbassador = true;
    return __createProductPlatformized;
}
/** Creates a new digital product. */
export function createDigitalProduct(payload) {
    var _a = serializer(_createDigitalProductRequest, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createDigitalProductResponse, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }).fromJSON;
    function __createDigitalProduct(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.CreateDigitalProduct',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products-digital',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createDigitalProduct.fromReq = fromReq;
    __createDigitalProduct.__isAmbassador = true;
    return __createDigitalProduct;
}
/**
 * Updates specified fields in a product.
 *
 * To update a single field across multiple products, use [Bulk Update Product Property](https://dev.wix.com/docs/rest/business-solutions/stores/catalog/bulk-update-product-property).
 */
export function updateProduct(payload) {
    var _a = serializer(_updateProductRequest, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateProductResponse, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }).fromJSON;
    function __updateProduct(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'PATCH',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.UpdateProduct',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products/{product.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateProduct.fromReq = fromReq;
    __updateProduct.__isAmbassador = true;
    return __updateProduct;
}
/** Updates specified fields in a product. */
export function updateProductPlatformized(payload) {
    var _a = serializer(_updateProductPlatformizedRequest, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateProductPlatformizedResponse, {
        _costAndProfitData: _costAndProfitData,
        _discount: _discount,
        _numericPropertyRange: _numericPropertyRange,
        _priceData: _priceData,
        _pricePerUnitData: _pricePerUnitData,
        _product: _product,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }).fromJSON;
    function __updateProductPlatformized(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'PATCH',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.UpdateProductPlatformized',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products-platformized/{product.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateProductPlatformized.fromReq = fromReq;
    __updateProductPlatformized.__isAmbassador = true;
    return __updateProductPlatformized;
}
/** Deletes a product. */
export function deleteProduct(payload) {
    var _a = serializer(_deleteProductRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteProductResponse, {}).fromJSON;
    function __deleteProduct(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'DELETE',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.DeleteProduct',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteProduct.fromReq = fromReq;
    __deleteProduct.__isAmbassador = true;
    return __deleteProduct;
}
/** Deletes a product. */
export function deleteProductPlatformized(payload) {
    var _a = serializer(_deleteProductPlatformizedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteProductPlatformizedResponse, {}).fromJSON;
    function __deleteProductPlatformized(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'DELETE',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.DeleteProductPlatformized',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products-platformized/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteProductPlatformized.fromReq = fromReq;
    __deleteProductPlatformized.__isAmbassador = true;
    return __deleteProductPlatformized;
}
/** Deletes a bulk of products. */
export function bulkDeleteProducts(payload) {
    var _a = serializer(_bulkDeleteProductsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteProductsResponse, {}).fromJSON;
    function __bulkDeleteProducts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'DELETE',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.BulkDeleteProducts',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/bulk/products/delete',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteProducts.fromReq = fromReq;
    __bulkDeleteProducts.__isAmbassador = true;
    return __bulkDeleteProducts;
}
/** Updates variants of a specified product. */
export function updateVariants(payload) {
    var _a = serializer(_updateVariantsRequest, { _variantOverride: _variantOverride }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateVariantsResponse, {
        _costAndProfitData: _costAndProfitData,
        _priceData: _priceData,
        _variant: _variant,
        _variantDataWithNoStock: _variantDataWithNoStock,
    }).fromJSON;
    function __updateVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'PATCH',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.UpdateVariants',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products/{id}/variants',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateVariants.fromReq = fromReq;
    __updateVariants.__isAmbassador = true;
    return __updateVariants;
}
/** Resets the data (such as the price and the weight) of all variants for a given product to their default values. */
export function resetAllVariantData(payload) {
    var _a = serializer(_resetAllVariantDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resetAllVariantDataResponse, {}).fromJSON;
    function __resetAllVariantData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.ResetAllVariantData',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products/{id}/variants/resetToDefault',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resetAllVariantData.fromReq = fromReq;
    __resetAllVariantData.__isAmbassador = true;
    return __resetAllVariantData;
}
/** Adds products to a specified collection. */
export function addProductsToCollection(payload) {
    var _a = serializer(_addProductsToCollectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addProductsToCollectionResponse, {}).fromJSON;
    function __addProductsToCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.AddProductsToCollection',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/collections/{id}/productIds',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addProductsToCollection.fromReq = fromReq;
    __addProductsToCollection.__isAmbassador = true;
    return __addProductsToCollection;
}
/** Deletes products from a specified collection. */
export function removeProductsFromCollection(payload) {
    var _a = serializer(_removeProductsFromCollectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeProductsFromCollectionResponse, {}).fromJSON;
    function __removeProductsFromCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.RemoveProductsFromCollection',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/collections/{id}/productIds/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeProductsFromCollection.fromReq = fromReq;
    __removeProductsFromCollection.__isAmbassador = true;
    return __removeProductsFromCollection;
}
/** Adds media items to a specified product, either via URL or existing media ID. */
export function addProductMedia(payload) {
    var _a = serializer(_addProductMediaRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addProductMediaResponse, {}).fromJSON;
    function __addProductMedia(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.AddProductMedia',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products/{id}/media',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addProductMedia.fromReq = fromReq;
    __addProductMedia.__isAmbassador = true;
    return __addProductMedia;
}
/**
 * Removes specified media items from a product.
 * Pass an empty array to remove all media items.
 */
export function removeProductMedia(payload) {
    var _a = serializer(_removeProductMediaRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeProductMediaResponse, {}).fromJSON;
    function __removeProductMedia(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.RemoveProductMedia',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products/{id}/media/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeProductMedia.fromReq = fromReq;
    __removeProductMedia.__isAmbassador = true;
    return __removeProductMedia;
}
/**
 * Links media items that are already associated with a specific product to a choice within the same product.
 *
 * Media items can only be set for choices within one option at a time - e.g., if you set media items for some or all of the choices within the Colors option (blue, green, and red), you won't be able to also assign media items to choices within the Size option (S, M, and L).
 *
 * To remove all existing media items, call the [Remove Product Media From Choices](https://dev.wix.com/api/rest/wix-stores/catalog/products/remove-product-media-from-choices) endpoint.
 */
export function addProductMediaToChoices(payload) {
    var _a = serializer(_addProductMediaToChoicesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addProductMediaToChoicesResponse, {}).fromJSON;
    function __addProductMediaToChoices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'PATCH',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.AddProductMediaToChoices',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products/{id}/choices/media',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addProductMediaToChoices.fromReq = fromReq;
    __addProductMediaToChoices.__isAmbassador = true;
    return __addProductMediaToChoices;
}
/**
 * Removes media items from all or some of a product's choices.
 * (Media items can only be set for choices within one option at a time - e.g., if you set media items for some or all of the choices within the Colors option (blue, green, and red), you won't be able to also assign media items to choices within the Size option (S, M, and L).)
 */
export function removeProductMediaFromChoices(payload) {
    var _a = serializer(_removeProductMediaFromChoicesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeProductMediaFromChoicesResponse, {}).fromJSON;
    function __removeProductMediaFromChoices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.RemoveProductMediaFromChoices',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products/{id}/choices/media/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeProductMediaFromChoices.fromReq = fromReq;
    __removeProductMediaFromChoices.__isAmbassador = true;
    return __removeProductMediaFromChoices;
}
/** Delete all options from a specific product. Only available when [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is disabled. */
export function deleteProductOptions(payload) {
    var _a = serializer(_deleteProductOptionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteProductOptionsResponse, {}).fromJSON;
    function __deleteProductOptions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'DELETE',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.DeleteProductOptions',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products/{id}/options',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteProductOptions.fromReq = fromReq;
    __deleteProductOptions.__isAmbassador = true;
    return __deleteProductOptions;
}
export function setCustomFields(payload) {
    var _a = serializer(_setCustomFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setCustomFieldsResponse, {}).fromJSON;
    function __setCustomFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.SetCustomFields',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products/{id}/set-custom-field',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setCustomFields.fromReq = fromReq;
    __setCustomFields.__isAmbassador = true;
    return __setCustomFields;
}
export function removeCustomFields(payload) {
    var _a = serializer(_removeCustomFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeCustomFieldsResponse, {}).fromJSON;
    function __removeCustomFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.RemoveCustomFields',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products/{id}/remove-custom-field',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeCustomFields.fromReq = fromReq;
    __removeCustomFields.__isAmbassador = true;
    return __removeCustomFields;
}
/** Deletes a product's brand. */
export function removeBrand(payload) {
    var _a = serializer(_removeProductBrandRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeProductBrandResponse, {}).fromJSON;
    function __removeBrand(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.RemoveBrand',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products/{id}/remove-brand',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeBrand.fromReq = fromReq;
    __removeBrand.__isAmbassador = true;
    return __removeBrand;
}
export function bulkSetCustomFields(payload) {
    var _a = serializer(_bulkSetCustomFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkSetCustomFieldsResponse, {}).fromJSON;
    function __bulkSetCustomFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.BulkSetCustomFields',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/bulk/products/set-custom-fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkSetCustomFields.fromReq = fromReq;
    __bulkSetCustomFields.__isAmbassador = true;
    return __bulkSetCustomFields;
}
export function bulkRemoveCustomFields(payload) {
    var _a = serializer(_bulkRemoveCustomFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkRemoveCustomFieldsResponse, {}).fromJSON;
    function __bulkRemoveCustomFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.BulkRemoveCustomFields',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/bulk/products/remove-custom-fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkRemoveCustomFields.fromReq = fromReq;
    __bulkRemoveCustomFields.__isAmbassador = true;
    return __bulkRemoveCustomFields;
}
/** Creates a new collection. */
export function createCollection(payload) {
    var _a = serializer(_createCollectionRequest, { _collection: _collection }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCollectionResponse, {
        _collection: _collection,
    }).fromJSON;
    function __createCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.CreateCollection',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/collections',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCollection.fromReq = fromReq;
    __createCollection.__isAmbassador = true;
    return __createCollection;
}
/**
 * Updates specified properties of a collection.
 * To add products to a collection, call the [Add Products to Collection](https://dev.wix.com/api/rest/wix-stores/catalog/collections/add-products-to-collection) endpoint.
 */
export function updateCollection(payload) {
    var _a = serializer(_updateCollectionRequest, { _collection: _collection }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCollectionResponse, {
        _collection: _collection,
    }).fromJSON;
    function __updateCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'PATCH',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.UpdateCollection',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/collections/{collection.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCollection.fromReq = fromReq;
    __updateCollection.__isAmbassador = true;
    return __updateCollection;
}
/** Deletes a collection. */
export function deleteCollection(payload) {
    var _a = serializer(_deleteCollectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCollectionResponse, {}).fromJSON;
    function __deleteCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'DELETE',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.DeleteCollection',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/collections/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCollection.fromReq = fromReq;
    __deleteCollection.__isAmbassador = true;
    return __deleteCollection;
}
/** Deletes a product's ribbon. */
export function removeRibbon(payload) {
    var _a = serializer(_removeProductRibbonRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeProductRibbonResponse, {}).fromJSON;
    function __removeRibbon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.RemoveRibbon',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/products/{id}/remove-ribbon',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeRibbon.fromReq = fromReq;
    __removeRibbon.__isAmbassador = true;
    return __removeRibbon;
}
/** Updates a specified property for up to 100 products at a time. */
export function bulkUpdateProducts(payload) {
    var _a = serializer(_bulkUpdateProductsRequest, { _setValue: _setValue }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateProductsResponse, {}).fromJSON;
    function __bulkUpdateProducts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.BulkUpdateProducts',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/bulk/products/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateProducts.fromReq = fromReq;
    __bulkUpdateProducts.__isAmbassador = true;
    return __bulkUpdateProducts;
}
/**
 * Updates a bulk of products, selected by filter.
 * The number of products that can be updated by filter is limited to 1000.
 * Internal only. Will be replaced in some point.
 */
export function bulkUpdateProductsByFilterSync(payload) {
    var _a = serializer(_bulkUpdateProductsByFilterSyncRequest, { _setValue: _setValue }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateProductsByFilterSyncResponse, {}).fromJSON;
    function __bulkUpdateProductsByFilterSync(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.BulkUpdateProductsByFilterSync',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/bulk/products/update-by-filter-sync',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateProductsByFilterSync.fromReq = fromReq;
    __bulkUpdateProductsByFilterSync.__isAmbassador = true;
    return __bulkUpdateProductsByFilterSync;
}
/**
 * Adjusts a specified numerical property for up to 100 products at a time.
 * The property can be increased or decreased either by percentage or amount.
 */
export function bulkAdjustProductProperties(payload) {
    var _a = serializer(_bulkAdjustProductPropertiesRequest, { _adjustValue: _adjustValue, _propertyAdjustmentData: _propertyAdjustmentData }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkAdjustProductPropertiesResponse, {}).fromJSON;
    function __bulkAdjustProductProperties(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.BulkAdjustProductProperties',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/bulk/products/adjust-properties',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkAdjustProductProperties.fromReq = fromReq;
    __bulkAdjustProductProperties.__isAmbassador = true;
    return __bulkAdjustProductProperties;
}
/**
 * Adjust property for multiple products, selected by filter.
 * The number of products that can be updated by filter is limited to 1000.
 * Internal only. Will be replaced at some point.
 */
export function bulkAdjustProductPropertiesByFilterSync(payload) {
    var _a = serializer(_bulkAdjustProductPropertiesByFilterSyncRequest, { _adjustValue: _adjustValue, _propertyAdjustmentData: _propertyAdjustmentData }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkAdjustProductPropertiesByFilterSyncResponse, {}).fromJSON;
    function __bulkAdjustProductPropertiesByFilterSync(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.BulkAdjustProductPropertiesByFilterSync',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/bulk/products/adjust-properties-by-filter-sync',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkAdjustProductPropertiesByFilterSync.fromReq = fromReq;
    __bulkAdjustProductPropertiesByFilterSync.__isAmbassador = true;
    return __bulkAdjustProductPropertiesByFilterSync;
}
export function reCloneStore(payload) {
    var _a = serializer(_reCloneStoreRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reCloneStoreResponse, {}).fromJSON;
    function __reCloneStore(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.product',
            method: 'GET',
            methodFqn: 'wix.catalog.api.v1.CatalogWriteApi.ReCloneStore',
            url: resolveWixCatalogApiV1CatalogWriteApiUrl({
                protoPath: '/v1/reclone',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reCloneStore.fromReq = fromReq;
    __reCloneStore.__isAmbassador = true;
    return __reCloneStore;
}
//# sourceMappingURL=http.impl.js.map